




























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Cropper } from "vue-advanced-cropper";

import { downloadImage } from "@/services/getImage";
import { splitString } from "@/services/strings";

import { type } from "@/config/files.config.json";
import { pics } from "@/config/host.config";

import Progress from "./progress.vue";
import StandartModal from "@/components/app/standart-modal.vue";

interface ICropCoordinates {
  left: number;
  top: number;
  width: number;
  height: number;
}

@Component({
  components: {
    StandartModal,
    Cropper,
    "progress-component": Progress,
  },
})
class UploadPicture extends Vue {
  @Prop({ type: String, default: "" }) image!: string;
  @Prop({ type: String, default: "" }) folder!: string;
  @Prop({ type: String, default: "poster" }) upload!: string;
  @Prop({ type: Number, default: 16 / 9 }) aspectRatio!: number;
  @Prop({ type: String, default: pics.newupload }) url!: string;
  @Prop({ type: String, default: null }) locale!: string;
  @Prop({ type: Boolean, default: false }) mobile!: boolean;
  @Prop({ type: String, default: "origin" }) subfolder!: string;

  ar = {
    aspectRatio: this.aspectRatio,
  };

  // progress
  poster_prodress_variant = "primary";
  poster_value_progress = 0;
  poster_progress = false;

  poster = this.image;
  posterName = "";

  file: null | File = null;
  fileOriginal: null | File = null;
  cropPromise: Promise<void> | null = null;

  $refs!: {
    file: HTMLInputElement;
  };

  // ------------------------------------------------------------------
  // State
  // ------------------------------------------------------------------

  savename = false;

  private objectUrl: string | null = null;

  poster_progress_variant = "primary";

  // ------------------------------------------------------------------
  // Computed
  // ------------------------------------------------------------------

  get modalId(): string {
    return `${this.upload}Modal`;
  }

  get imagePath(): string {
    return this.locale
      ? `${this.folder}/${this.locale}/origin`
      : `${this.folder}/origin`;
  }

  get previewImage(): string {
    return this.$getWebImage(this.image, this.imagePath);
  }

  get emptyImage(): string {
    return `this.onerror=null;this.src='${this.$getImage("empty.png", null)}';`;
  }

  get stencilProps() {
    return {
      aspectRatio: this.aspectRatio,
    };
  }

  // ------------------------------------------------------------------
  // Utils
  // ------------------------------------------------------------------

  private revokeObjectUrl(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }

  private async createFileFromCanvas(
    canvas: HTMLCanvasElement
  ): Promise<File | null> {
    if (!this.fileOriginal) return null;

    const parts = this.fileOriginal.name.split(".");
    const extension = parts.pop()?.toLowerCase();

    const format =
      extension === "png" || extension === "webp" ? "webp" : "jpeg";

    const quality = format === "jpeg" ? 0.98 : 1;

    const blob = await new Promise<Blob | null>((resolve) => {
      canvas.toBlob((blob) => resolve(blob), `image/${format}`, quality);
    });

    if (!blob) {
      return null;
    }

    const fileName = this.savename ? parts.join(".") || "image" : "image";

    return new File([blob], `${fileName}.${format}`, {
      type: blob.type,
      lastModified: Date.now(),
    });
  }

  // ------------------------------------------------------------------
  // Events
  // ------------------------------------------------------------------

  isUpload(): void {
    this.fileOriginal = this.$refs.file.files ? this.$refs.file.files[0] : null;
    if (this.fileOriginal)
      this.poster = URL.createObjectURL(new Blob([this.fileOriginal]));
  }

  isChange({ coordinates }: { coordinates: ICropCoordinates }): void {
    if (!this.fileOriginal || !coordinates) return;
    this.cropPromise = this.buildCroppedFile(coordinates);
  }

  private loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  private async buildCroppedFile(coordinates: ICropCoordinates): Promise<void> {
    if (!this.fileOriginal) return;
    const namearr = this.fileOriginal.name.split(".");
    const ftype = namearr.length ? namearr.pop() : "";
    let outType = "jpeg";
    let quality = 0.95;
    if (ftype == "png") {
      outType = "png";
      quality = 1;
    } else if (ftype == "webp") {
      outType = "webp";
      quality = 0.95;
    }

    const objectUrl = URL.createObjectURL(new Blob([this.fileOriginal]));
    try {
      const img = await this.loadImage(objectUrl);
      const cw = Math.max(1, Math.round(coordinates.width));
      const ch = Math.max(1, Math.round(coordinates.height));
      const canvas = document.createElement("canvas");
      canvas.width = cw;
      canvas.height = ch;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      ctx.drawImage(
        img,
        Math.round(coordinates.left),
        Math.round(coordinates.top),
        cw,
        ch,
        0,
        0,
        cw,
        ch
      );
      const blob: Blob | null = await new Promise((resolve) =>
        canvas.toBlob(
          (b: Blob | null) => resolve(b),
          `image/${outType}`,
          quality
        )
      );
      if (!blob) return;
      const name = this.savename && namearr.length ? namearr.join(".") : "name";
      this.file = new File([blob], `${name}.${outType}`, {
        type: `image/${outType}`,
      });
    } finally {
      URL.revokeObjectURL(objectUrl);
    }
  }

  isError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  } // ------------------------------------------------------------------
  // Upload
  // ------------------------------------------------------------------

  async isOk(event: Event): Promise<void> {
    event.preventDefault();
    if (this.cropPromise) {
      await this.cropPromise;
      this.cropPromise = null;
    }
    if (!this.file) return this.isError();

    const formData: FormData = new FormData();
    formData.append("poster", this.file);

    try {
      const response = await this.$axios.post(this.url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },

        // Был onDownloadProgress
        // Для отправки файлов нужен именно UploadProgress
        onUploadProgress: (event: ProgressEvent) => {
          if (!event.total) return;

          this.poster_value_progress = Math.round(
            (event.loaded * 100) / event.total
          );
        },

        params: {
          path: this.folder,
          savename: this.savename,
          lang: this.locale || undefined,
        },
      });

      if (response.status === 200) {
        this.$emit("name", response.data);
        this.$bvModal.hide(this.modalId);
      }
    } catch (error) {
      console.error(error);

      this.poster_progress_variant = "danger";
      this.isError();
    } finally {
      this.poster_progress = false;
    }
  }

  // ------------------------------------------------------------------
  // Image loading
  // ------------------------------------------------------------------

  @Watch("image")
  async makeActive(): Promise<void> {
    if (!this.image) return;
    const path = this.locale
      ? this.folder + "/" + this.locale + "/" + this.subfolder
      : this.folder + "/" + this.subfolder;

    downloadImage(pics.download, this.image, path)
      .then((image: Blob) => {
        this.poster = URL.createObjectURL(new Blob([image]));
        this.posterName = this.image;
      })
      .catch((error) => {
        console.log(error);
        this.isError();
      });
  }

  fileFormat(fileType: string | undefined): boolean {
    if (!fileType) {
      return false;
    }

    const parts = splitString(fileType, "/");
    return type.image.includes(parts[parts.length - 1]);
  }

  onReset(): void {
    this.file = null;
    this.fileOriginal = null;

    this.savename = false;
    this.cropPromise = null;
    this.makeActive();
  }

  // ------------------------------------------------------------------
  // Lifecycle
  // ------------------------------------------------------------------

  mounted(): void {
    this.makeActive();
  }

  beforeDestroy(): void {
    this.revokeObjectUrl();
  }
}
export default UploadPicture;
